import { render } from "./rolelogin.vue?vue&type=template&id=b8869b98"
import script from "./rolelogin.vue?vue&type=script&lang=js"
export * from "./rolelogin.vue?vue&type=script&lang=js"

import "./rolelogin.vue?vue&type=style&index=0&id=b8869b98&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__